<p class="mb-4">
  <strong>Mobile Media Content, S.L.</strong> (hereinafter
  "<strong>MMC</strong>") is the owner of the Web Site
  <a href="https://3ddigitalvenue.com/" target="_blank"
    >https://3ddigitalvenue.com/</a
  >
  (hereinafter the "Web Site") and is responsible as the data processor for the
  personal data of its users (hereinafter the "Users"). Through this Privacy
  Policy, and in compliance with Articles 12 and 13 of Regulation (EU) 2016/679
  (hereinafter "GDPR") and Article 11 of Organic Law 3/2018, of December 5, on
  the Protection of Personal Data and guarantee of digital rights ("LOPDPGDD"),
  MMC informs Users using the Website about the processing of their personal
  data that may be collected through this and processed by MMC.
</p>

<h2 class="mb-4">1. INFORMATION ABOUT THE DATA PROCESSOR</h2>

<p class="mb-4">
  <strong>Data Processor:</strong> Mobile Media Content, S.L.<br />
  <strong>TAX ID:</strong> B65799454.<br />
  <strong>Registered office:</strong> C/ Àlaba 61, 6th 1 A-2, 08005 Barcelona,
  Spain.<br />
  <strong>Contact us: </strong>
  <a class="select-none">dpo&#64;mobilemediacontent.com</a>
</p>

<h2 class="mb-4">2. INFORMATION ABOUT THE DATA CONTROLLER</h2>

<p class="mb-4">
  <strong>Data Controller:</strong> MLB Advanced Media, L.P. ("MLB")<br />
  <strong>TAX ID:</strong> 13-4138913.<br />
  <strong>Registered office:</strong> 1271 Avenue of the Americas, New York, NY
  10020<br />
  <strong>Contact us: </strong>
  <a class="select-none">dataprivacy&#64;mlb.com</a>
</p>

<p class="mb-4">
  For more general information about the Data Controller, please see the
  following
  <a
    class="cursor-pointer"
    (click)="displaySectionEmitter.emit('Privacy Policy')"
    >Privacy Policy</a
  >
</p>

<h2 class="mb-4">
  1. DATA PROCESSED BY THE PROCESSOR, LEGAL BASIS, PURPOSES AND STORAGE PERIOD.
</h2>

<div class="overflow-auto">
  <table class="mb-4 w-full border-collapse">
    <thead>
      <tr class="border-b">
        <th class="p-2 text-left">Data processed</th>
        <th class="p-2 text-left">Legal Basis</th>
        <th class="p-2 text-left">Purposes</th>
        <th class="p-2 text-left">Conservation period</th>
      </tr>
    </thead>
    <tbody>
      <tr class="border-b align-top">
        <td class="p-2">
          <strong>Browsing data.</strong> Due to Internet communication
          standards, when the User accesses our Web Site we automatically
          receive the IP address of your computer and the type of browser you
          are using. We use this information to analyze general trends and
          improve the service. This information is not shared with third parties
          without your consent.
        </td>
        <td class="p-2">
          Consent of the person concerned.<br />Legitimate interest.
        </td>
        <td class="p-2">
          <strong>Analysis of browsing behavior and statistics:</strong> The
          information collected through cookies and other similar tracking
          technologies allow an analysis of the navigation made by Users.
        </td>
        <td class="p-2">
          The retention periods depend on each specific cookie. For more
          information on the information retention periods for each type of
          cookie, please consult the Cookies Policy.
        </td>
      </tr>
    </tbody>
  </table>
</div>

<h2 class="mb-4">2. TO WHICH RECIPIENTS WILL YOUR DATA BE COMMUNICATED?</h2>

<p class="mb-4">
  <strong>MMC</strong>, as Data Processor, informs that, for the fulfillment of
  the purposes described above, it will not transfer the User's personal data to
  third parties. Notwithstanding the foregoing, MMC may give access to such
  personal data to:
</p>

<ul class="list-disc list-inside mb-4 text-sm">
  <li class="mb-2">
    Technology service providers with which it has entered into a processor
    contract;
  </li>
</ul>

<p class="mb-4">
  The aforementioned providers may be located in jurisdictions that generally do
  not provide adequate safeguards in relation to the processing of personal
  data. For all entities that are not part of the European Economic Area (EEA),
  MMC has entered into contracts with such entities that include such
  safeguards, including the European Commission's model clauses.
</p>

<p class="mb-4">
  Users may obtain more information about technology service providers by
  requesting the same from MMC through the means of contact provided in this
  privacy policy.
</p>

<p class="mb-4">Also, MMC may communicate your data, to:</p>

<ul class="list-disc list-inside mb-4 text-sm">
  <li>
    Authorities to investigate suspected fraud, harassment or other violations
    of any law, rule or regulation, or of the website policies.
  </li>
</ul>

<h2 class="mb-4">3. SECURITY AND CONFIDENTIALITY</h2>

<p class="mb-4">
  MMC undertakes to adopt the necessary technical and organizational measures,
  in accordance with the provisions of the applicable regulations, to ensure the
  security of personal data and prevent the accidental or unlawful destruction,
  loss or alteration of personal data transmitted, stored or otherwise
  processed, or unauthorized communication or access to such data. Personal data
  will be treated confidentially by MMC which undertakes to inform and enforce,
  by legal or contractual obligation, such confidentiality to its employees,
  partners and any person who should have access to the User's personal data.
</p>

<h2 class="mb-4">4. USERS' RIGHTS</h2>

<p class="mb-4">
  The User may exercise the rights of access, rectification, deletion,
  opposition and, where appropriate, limitation of processing and portability of
  data by sending an email to
  <a class="select-none">dpo&#64;mobilemediacontent.com</a>. Likewise, the User
  may file a complaint with a supervisory authority and, in particular, with the
  Spanish Data Protection Agency (<a href="http://www.aepd.es" target="_blank"
    >www.aepd.es</a
  >) if he/she considers that the rights set forth above in this Privacy Policy
  have been violated or if he/she considers that the processing of personal data
  concerning him/her violates the applicable regulations.
</p>

<h2 class="mb-4">5. CHANGES IN THE PRIVACY POLICY</h2>

<p class="mb-4">
  MMC reserves the right to modify this Privacy Policy at any time. Changes or
  updates to the Privacy Policy will be explicitly notified to the User by means
  of a notice on the Website, together with the updated version of the Privacy
  Policy.
</p>

<div class="last-updated">Latest version: 2025/04/01</div>
